module.exports = __webpack_public_path__ + "static/media/chess.cfdb9df3.png";